import {
    DEALERSAMPLEFILE_SUCCESS,
    DEALERSAMPLEFILE_FAILED,
    RESET_DEALERSAMPLEFILE,
    LOADING_DEALERSAMPLEFILE,
    NETWORK_ERROR_DEALERSAMPLEFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerSampleFile = () => {
    return { type: RESET_DEALERSAMPLEFILE };
}

const dealerSampleFileList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERSAMPLEFILE });
    await dealerServices
        .post("sampleFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerSampleFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerSampleFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERSAMPLEFILE,
                payload: err
            });
        });
}

function dealerSampleFilesuccess(data) {
    return {
        type: DEALERSAMPLEFILE_SUCCESS,
        payload: data
    };
}

function dealerSampleFileFailed(data) {
    return {
        type: DEALERSAMPLEFILE_FAILED,
        payload: data
    };
}

export { resetDealerSampleFile, dealerSampleFileList }